import React from "react";
import { FormFull } from "form-full";
import Styles from "../styles/";
import { Grid } from "@material-ui/core";
import {
  CustomText,
  Input,
  InputAutocomplete,
  InputDate,
} from "../../../components/index";
import { Label } from "../../../components/inputs/Input";
import { fonts, Spacing } from "../../../config";
import { addOneDay } from "../../registerTenant/components/ModalRegistry";
import { masks, validations } from "../../../utils";
import { AccessTime } from "@material-ui/icons";

function Filters({ onSubmit, loading, statusList, placeList }) {
  const [formRef, setFormRef] = React.useState<any>(null);
  const [minDate, setMinDate] = React.useState<any>(null);

  return (
    <FormFull formRef={setFormRef} onSubmit={(data) => onSubmit(data)}>
      <Grid alignItems="flex-end" container spacing={1}>
        <Grid item xs={6} md={6} lg={3}>
          <div style={{ paddingTop: "9px" }}>
            <Input name="guestName" label="Nome Usuario" placeholder="Nome Usuario" />
          </div>
        </Grid>
        <Grid container item xs={6} md={6} lg={3}>
            <InputAutocomplete
              readOnly={false}
              name="placeId"
              label="Studio"
              options={placeList ? placeList : []}
            />
        </Grid>
        <Grid container item xs={12} md={12} lg={6} >
          <div style={{ display: "flex" , flexDirection: "row", alignItems: "center" , width: "100%"}}>
            <div style={{ width: "100%"}}>
              <Label style={{ marginBottom: "11px"}}>CHECK-IN / CHECK-OUT </Label>
              <InputDate
                onChange={(value) => {
                  setMinDate(value);
                  const end = formRef?.getValue("maxEndDate");

                  if (end < value) {
                    formRef?.clearValue("maxEndDate", false);
                  }
                }}
                name="minStartDate"
              />
            </div>
            <p style={{ padding: "0px 10px"}}>até</p>
            <div style={{ width: "100%", marginTop: "auto" }}>
              <InputDate minDate={addOneDay(minDate)} name="maxEndDate" />
            </div>
          </div>
        </Grid>
        <Grid item xs={6} md={6} lg={3}>
            <Input name="guestEmail" label="Email" placeholder="Email" />
        </Grid>
        <Grid item xs={6} md={6} lg={3}>
          <div style={{ paddingTop: "9px" }}>
            <Input
              name="nhospedes"
              label="Nº Acompanhantes"
              placeholder="0"
            />
          </div>
        </Grid>
        <Grid container item xs={6} md={6} lg={3}>
          <Label style={{ marginBottom: "11px"}} >DATA SOLICITAÇÃO</Label>
          <InputDate
            onChange={(value) => {
              //console.log(value);
            }}
            name="solicitationDate"
          />
        </Grid>
        <Grid item xs={6} md={6} lg={3}>
            <InputAutocomplete
              readOnly={false}
              name="status"
              label="Status"
              options={statusList ? statusList : []}
            />
        </Grid>
      </Grid>
      <Styles.ButtonContainer>
        <Styles.Clear
          loading={loading}
          disabled={loading}
          fullWidth={false}
          action="clear"
        >
          Limpar
        </Styles.Clear>
        <Styles.Submit
          loading={loading}
          disabled={loading}
          fullWidth={false}
          action="submit"
        >
          Aplicar Filtros
        </Styles.Submit>
      </Styles.ButtonContainer>
    </FormFull>
  );
}

export default Filters;

